import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-acknowledge-modal',
  templateUrl: './acknowledge-modal.component.html',
  styleUrls: ['./acknowledge-modal.component.css'],
})
export class AcknowledgeModalComponent implements OnInit {
  @Input() headerText = 'Acknowledge';
  @Input() bodyText = '';
  @Input() closeButtonText = 'Close';

  constructor(private ngbActiveModal: NgbActiveModal) {}

  ngOnInit(): void {}

  closeModal() {
    this.ngbActiveModal.close();
  }
}
